import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';
import { api } from 'src/service';
import SettlementListToolbar from '../../components/settlement/SettlementListToolbar';
import ProviderSettlement from '../../components/settlement/ProviderSettlement';
import { usePersistedPagerInfo } from 'src/utils/usePersistedLimit';

const Settings = () => {
  const [settlements, setSettlements] = useState();
  const [loading1, setLoading1] = useState(false);
  const [searchStr, setSearchStr] = useState('');
  const [pagerInfo, setPagerInfo] = usePersistedPagerInfo('settlement', { limit: 10 });

  useEffect(() => {
    setLoading1(true);
    const fetchData = async () => {
      try {
        await api
          .post('/backoffice/settlement/filter', {
            page_size: pagerInfo.limit,
            current_page: pagerInfo.page,
            search: searchStr,
          })
          .then((res) => {
            setSettlements(res.data.data.data);
            setPagerInfo({
              limit: res.data.data.page_size,
              page: res.data.data.current_page,
              totalSize: res.data.data.total_size,
            });
          });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[settlement] fetch failed', error);
        setSettlements([]);
      } finally {
        setLoading1(false);
      }
    };

    fetchData();
  }, [searchStr, pagerInfo.page, pagerInfo.limit]);

  const handleSearchStr = (str) => {
    setSearchStr(str);
  };

  const handlePagerInfo = (info) => {
    setPagerInfo(info);
  };

  return (
    <>
      <Helmet>
        <title>Washer - Settlement</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <SettlementListToolbar handleSearchStr={handleSearchStr} />
          <Box sx={{ pt: 3 }}>
            <ProviderSettlement
              settlements={settlements}
              loading={loading1}
              pagerInfo={pagerInfo}
              handlePagerInfo={handlePagerInfo}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Settings;
